import * as React from 'react'
import UploadFiles from './project-files';

interface ProjectQuesAnsProps {
    ProjectQuestion?: any,
    ProjectAnswer?: any,
    DimensionTitle?: any,
    questionTitle?: any,
    widthDimension?: any,
    heightDimension?: any,
    lengthDimension?: any,
    unit?: any,
    type?: any,
    filethumbnail?: any,
    filename?: any
}

class ProjectQuestionAnswer extends React.Component<ProjectQuesAnsProps> {
    render() {
        const { ProjectQuestion, ProjectAnswer, type, questionTitle, DimensionTitle, widthDimension, lengthDimension, heightDimension, unit, filethumbnail, filename } = this.props;

        if(type === "ec-project__question-item--dimension") {
            return (
                <div className={`ec-project__question-item ${type}`}>
                    <span className="ec-project__question">{questionTitle} - {DimensionTitle}: </span>
                    <div className="ec-project__answer-dimension">
                        <div className="ec-project__dimention-width d-flex align-items-center mb-2">
                            <span className="ec-project__question mb-0 mr-2">Length:</span> <span className="ec-project__answer">{lengthDimension} {unit} </span>
                        </div>
                        <div className="ec-project__dimention-height d-flex align-items-center mb-2">
                            <span className="ec-project__question mb-0 mr-2">Width:</span> <span className="ec-project__answer">{widthDimension} {unit} </span>
                        </div>
                        <div className="ec-project__dimention-height d-flex align-items-center mb-2">
                            <span className="ec-project__question mb-0 mr-2">Height:</span> <span className="ec-project__answer">{heightDimension} {unit} </span>
                        </div>
                    </div>
                </div>
            )
        }
        else if(type === "ec-project__question-item--files") {
            return (
                <div className="ec-project__question-item">
                        <span className="ec-project__question">Files</span>
                        <UploadFiles filethumbnail={filethumbnail} filename={filename} />
                </div>
            )
        }
        else {
            return (
                <div className="ec-project__question-item">
                    <span className="ec-project__question">{ProjectQuestion}</span>
                    <span className="ec-project__answer">{ProjectAnswer}</span>
                </div>
            )
        }
    }
}

export default ProjectQuestionAnswer;